<template>
  <div id="registration">
    <v-app id="inspire">
      <div class="row">
        <div class="col-md-6 login-form-1">
          <h3>Sign In With </h3>

          <div class="form-group">
            <input type="text" class="form-control" placeholder="Your Email *" value />
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="Your Password *" value />
          </div>
          <div class="form-group">
            <input type="submit" class="btnSubmit" value="Login" />
          </div>
          <div class="form-group">
            <a href="#" class="btnForgetPwd">Forget Password?</a>
          </div>
        </div>
        <div class="col-md-6 login-form-2">
          <div class="login-logo">
            <img src="https://image.ibb.co/n7oTvU/logo_white.png" alt />
          </div>
          <h3>Login Form 2</h3>
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Your Email *" value />
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="Your Password *" value />
          </div>
          <div class="form-group">
            <input type="submit" class="btnSubmit" value="Login" />
          </div>
          <div class="form-group">
            <a href="#" class="btnForgetPwd" value="Login">Forget Password?</a>
          </div>
        </div>
      </div>
      <!-- <v-tabs
        centered
        color="deep-purple accent-1"
        slot="extension"
        slider-color="yellow"
        v-model="model"
      >
        <v-tab href="#tab-1">Solar Panels</v-tab>

        <v-tab href="#tab-2">CCTV Panels</v-tab>

        <v-tab href="#tab-3">LED Lights</v-tab>
      </v-tabs> -->

      <!-- <v-tabs-items>
        <v-tabs-content id="tab-1">
          <v-card flat>
            <v-card-text>This is the first tab</v-card-text>
          </v-card>
        </v-tabs-content>
        <v-tabs-content id="tab-2">
          <v-card flat>
            <v-card-text>This is the second tab</v-card-text>
          </v-card>
        </v-tabs-content>
        <v-tabs-content id="tab-3">
          <v-card flat>
            <v-card-text>This is the third tab</v-card-text>
          </v-card>
        </v-tabs-content>
      </v-tabs-items> -->

      <v-tabs>
        <v-tab
        key="tab-1"
          background-color="deep-purple accent-4"
          class="elevation-2"
          dark
          :centered="centered"
          :grow="grow"
          :vertical="vertical"
          :right="right"
          :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
          :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
          :icons-and-text="icons"
          href="#tab-1"
        >Item One</v-tab>
        <v-tab href="#tab-2">Item Two</v-tab>
        <v-tab href="#tab-3">Item Three</v-tab>
      </v-tabs>

      <v-tabs-items>
            <v-tab-item key="tab-1">
                 <v-card flat tile>
                     <p>kamleshkns</p>
                 </v-card>
            </v-tab-item>
      </v-tabs-items>

      <!-- <v-tabs
        v-model="tab"
        background-color="deep-purple accent-4"
        class="elevation-2"
        dark
        :centered="centered"
        :grow="grow"
        :vertical="vertical"
        :right="right"
        :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
        :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
        :icons-and-text="icons"
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab v-for="i in tabs" :key="i" :href="`#tab-${i}`">
          Tab {{ i }}
          <v-icon v-if="icons">mdi-phone</v-icon>
        </v-tab>

        <v-tab-item v-for="i in tabs" :key="i" :value="'tab-' + i">
          <v-card flat tile>
            <v-card-text>{{ text }}</v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs> -->
    </v-app>
  </div>
</template>
<style scoped>
.login-container {
  margin-top: 5%;
  margin-bottom: 5%;
}
.login-logo {
  position: relative;
  margin-left: -41.5%;
}
.login-logo img {
  position: absolute;
  width: 20%;
  margin-top: 19%;
  background: #282726;
  border-radius: 4.5rem;
  padding: 5%;
}
.login-form-1 {
  padding: 9%;
  background: #282726;
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19);
}
.login-form-1 h3 {
  text-align: center;
  margin-bottom: 12%;
  color: #fff;
}
.login-form-2 {
  padding: 9%;
  background: #f05837;
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19);
}
.login-form-2 h3 {
  text-align: center;
  margin-bottom: 12%;
  color: #fff;
}
.btnSubmit {
  font-weight: 600;
  width: 50%;
  color: #282726;
  background-color: #fff;
  border: none;
  border-radius: 1.5rem;
  padding: 2%;
}
.btnForgetPwd {
  color: #fff;
  font-weight: 600;
  text-decoration: none;
}
.btnForgetPwd:hover {
  text-decoration: none;
  color: #fff;
}
</style>
<script>
export default {
  name: "registration",
  data() {
    return {
      tab: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      icons: false,
      centered: false,
      grow: false,
      vertical: false,
      prevIcon: false,
      nextIcon: false,
      right: false,
      tabs: 3
    };
  }
};
</script>